'use strict';
Object.defineProperty(exports, '__esModule', { value : true });
exports.hop = void 0;
exports.hop = (o, p) => Object.prototype.hasOwnProperty.call(o, p);
